"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var idb = tslib_1.__importStar(require("idb-keyval"));
var consola_1 = tslib_1.__importDefault(require("consola"));
var runtime_context_1 = require("@drapejs/runtime-context");
var supportsIdb = typeof indexedDB !== 'undefined';
var itemUpdatedMessageType = "cacheItemUpdated";
var ItemUpdatedMessage = /** @class */ (function () {
    function ItemUpdatedMessage(key, item) {
        this.key = key;
        this.item = item;
        this.__messageType = itemUpdatedMessageType;
    }
    return ItemUpdatedMessage;
}());
function getItemUpdatedMessage(message) {
    var data = message === null || message === void 0 ? void 0 : message.data;
    if ((data === null || data === void 0 ? void 0 : data.__messageType) === itemUpdatedMessageType) {
        return data;
    }
}
var default_1 = /** @class */ (function () {
    function default_1() {
        this.subscriptions = {};
        /**
         * memoryCache is used as an indexedDB fallback when there's no support
         */
        this.memoryCache = {};
    }
    /**
     * Tells this cache instance to listen for updates to cache from the specified worker.
     * @param worker
     */
    default_1.prototype.listen = function (worker) {
        var _this = this;
        if (runtime_context_1.isBrowser()) {
            consola_1.default.trace("Cache: Listen to messages from worker", worker);
            worker.addEventListener('message', function (m) {
                var data = getItemUpdatedMessage(m);
                if (data) {
                    consola_1.default.trace("Cache: Received item update from woker", m);
                    _this.triggerSubscriptions(data.key, data.item);
                }
            });
        }
    };
    default_1.prototype.getAllItems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (supportsIdb) {
                    // TODO implement using idb.entries
                    throw "Not implemented yet";
                }
                else {
                    return [2 /*return*/, this.memoryCache];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Adds all the fields in the specified object to cache
     * @param values
     */
    default_1.prototype.setManyItems = function (values) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var forIdb_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!supportsIdb) return [3 /*break*/, 2];
                        forIdb_1 = [];
                        Object.keys(values).forEach(function (key) {
                            forIdb_1.push([key, values[key]]);
                        });
                        return [4 /*yield*/, idb.setMany(forIdb_1)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2: throw "Not implemented yet";
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.getItem = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (supportsIdb) {
                    return [2 /*return*/, idb.get(key)];
                }
                else {
                    return [2 /*return*/, this.memoryCache[key]];
                }
                return [2 /*return*/];
            });
        });
    };
    default_1.prototype.setItem = function (key, val) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var post, op;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        post = function () {
                            if (runtime_context_1.isWorker()) {
                                consola_1.default.trace("Posting message to UI", self);
                                runtime_context_1.postMessage(new ItemUpdatedMessage(key, val));
                            }
                            else {
                                _this.triggerSubscriptions(key, val);
                            }
                        };
                        if (!supportsIdb) return [3 /*break*/, 2];
                        op = idb.set(key, val);
                        post();
                        return [4 /*yield*/, op];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.memoryCache[key] = val;
                        post();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.subscribe = function (key, handler, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var val, val;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (runtime_context_1.isWorker()) {
                            throw "Subscriptions are not supported in worker context.";
                        }
                        if (!this.subscriptions[key]) {
                            this.subscriptions[key] = [];
                        }
                        consola_1.default.trace("Cache: Adding subscription handler forz " + key);
                        this.subscriptions[key].push(handler);
                        if (!(options === null || options === void 0 ? void 0 : options.immediate)) return [3 /*break*/, 3];
                        if (!supportsIdb) return [3 /*break*/, 2];
                        return [4 /*yield*/, idb.get(key)];
                    case 1:
                        val = _a.sent();
                        if (val) {
                            consola_1.default.trace("Cache: " + key + " found in cache, firing handler immediately upon subscription");
                            handler(val);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        val = this.memoryCache[key];
                        if (val) {
                            handler(val);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.unsubscribe = function (key, handler) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var index;
            return tslib_1.__generator(this, function (_a) {
                if (runtime_context_1.isWorker()) {
                    throw "Subscriptions are not supported in worker context.";
                }
                if (!this.subscriptions[key]) {
                    return [2 /*return*/];
                }
                index = this.subscriptions[key].indexOf(handler);
                if (index >= 0) {
                    this.subscriptions[key].splice(index, 1);
                }
                return [2 /*return*/];
            });
        });
    };
    default_1.prototype.triggerSubscriptions = function (key, item) {
        if (this.subscriptions[key]) {
            var handlers = this.subscriptions[key];
            handlers.forEach(function (h) { return h(item); });
        }
    };
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=index.js.map